import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllCodeGroups,
  onCreateCodeGroup,
  onDeleteCodeGroup,
  onGetCodeGroup,
  onUpdateCodeGroup,
} from '../../../app/modules/base-definitions/components/code-group/core/_requests'
interface CodeGroupState {
  codeGroups: any
  codeGroup: any
  isLoading: boolean
}
const initialState = {
  codeGroups: [],
  codeGroup: null,
  isLoading: true,
} as CodeGroupState

export const fetchCodeGroups = createAsyncThunk('codeGroup/fetchCodeGroups', async (param: any) => {
  const data: any = await onGetPagedAllCodeGroups(param)
  return data.data.result
})

export const fetchCodeGroup = createAsyncThunk('codeGroup/fetchCodeGroup', async (param: any) => {
  const data: any = await onGetCodeGroup(param)
  return data.data.result
})

export const updateCodeGroup = createAsyncThunk('codeGroup/updateCodeGroup', async (param: any) => {
  const data: any = await onUpdateCodeGroup(param)
  return data.data
})

export const createCodeGroup = createAsyncThunk('codeGroup/createCodeGroup', async (param: any) => {
  const data: any = await onCreateCodeGroup(param)
  return data.data
})

export const deleteCodeGroup = createAsyncThunk('codeGroup/deleteCodeGroup', async (param: any) => {
  const data: any = await onDeleteCodeGroup(param)
  return data.data
})

const codeGroupSlice = createSlice({
  name: 'codeGroup',
  initialState,
  reducers: {
    clearCodeGroups: (state) => {
      state.codeGroups = []
    },
    clearCodeGroup: (state) => {
      state.codeGroup = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCodeGroups.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchCodeGroups.fulfilled, (state: any, action) => {
      state.codeGroups = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchCodeGroups.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchCodeGroup.fulfilled, (state: any, action) => {
      state.codeGroup = action.payload
    })
  },
})

export const {clearCodeGroups, clearCodeGroup, activateLoading} = codeGroupSlice.actions

export default codeGroupSlice.reducer
